import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = {
  class: "introduction-check-area"
};
var _hoisted_3 = {
  key: 0,
  class: "introduction-popup-wrapper"
};
var _hoisted_4 = {
  class: "introduction-popup-content-box"
};
var _hoisted_5 = {
  class: "introduction-popup-title-chunk"
};
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = {
  class: "introduction-popup-btn-box"
};
import { ref, computed, watch, onMounted } from 'vue';
import { useLess } from '@/models/hooks';
import constants from '@/constants';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
export default {
  __name: 'Introduction',
  props: {
    properties: {
      type: Object,
      require: true,
      default: () => {
        return {};
      }
    }
  },
  setup(__props) {
    var props = __props;
    useLess('views/landingPage/introduction/Introduction.less');
    var store = useStore();
    var route = useRoute();
    var IMAGE_URL = constants.IMAGE_URL;
    var rightArrowIcon = `${IMAGE_URL}/assets/svg/rightArrowIntroduction.svg`;
    var introductionCloseIcon = `${IMAGE_URL}/assets/svg/introductionCloseIcon.svg`;
    var isShowPopup = ref(false);
    var richTextObj = ref({
      title: '',
      content: ''
    });

    // phone bottom security height
    var phoneBottomSecurityHeight = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.phoneBottomSecurityHeight) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    var onClickDetail = () => {
      isShowPopup.value = true;
    };
    var onClickClose = () => {
      isShowPopup.value = false;
    };
    watch(() => {
      var _props$properties, _props$properties2;
      return [(_props$properties = props.properties) === null || _props$properties === void 0 ? void 0 : _props$properties.titleName, (_props$properties2 = props.properties) === null || _props$properties2 === void 0 ? void 0 : _props$properties2.content];
    }, ([titleNameNewVal, contentNewVal]) => {
      if (titleNameNewVal) {
        richTextObj.value.title = titleNameNewVal.replaceAll(`target="_blank"`, '');
      }
      if (contentNewVal) {
        richTextObj.value.content = contentNewVal.replaceAll(`target="_blank"`, '');
      }
    }, {
      deep: true,
      immediate: true
    });
    onMounted(() => {
      var recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.introductionWidget), recordParams));
    });
    return (_ctx, _cache) => {
      var _component_van_popup = _resolveComponent("van-popup");
      var _directive_loading = _resolveDirective("loading");
      return __props.properties.isShow === 'DISPLAY' ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{
          'introduction-container-bottom6': __props.properties.bottomSpacing == '6'
        }, {
          'introduction-container-bottom12': __props.properties.bottomSpacing == '12'
        }, {
          'introduction-container-bottom20': __props.properties.bottomSpacing == '20'
        }, 'introduction-container'])
      }, [_createElementVNode("div", {
        class: "introduction-wrapper",
        innerHTML: richTextObj.value.title
      }, null, 8, _hoisted_1), _createElementVNode("div", {
        class: "introduction-wrapper",
        onClick: onClickDetail
      }, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('button.VIEW_DETAIL')), 1), _createElementVNode("img", {
        class: "introduction-check-icon-area",
        src: rightArrowIcon,
        alt: ""
      })]), isShowPopup.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_van_popup, {
        show: isShowPopup.value,
        position: "bottom",
        round: true,
        teleport: "#app",
        onClickOverlay: onClickClose,
        class: "introduction-popup"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "introduction-popup-area",
          style: _normalizeStyle({
            marginBottom: phoneBottomSecurityHeight.value + 'px'
          })
        }, [_createElementVNode("div", {
          class: "introduction-popup-close",
          onClick: onClickClose
        }, [_createElementVNode("img", {
          src: introductionCloseIcon,
          alt: ""
        })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('common.ILLUSTRATE')), 1), _createElementVNode("div", {
          class: "introduction-popup-content-chunk",
          innerHTML: richTextObj.value.content
        }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          class: "introduction-popup-btn",
          onClick: onClickClose
        }, _toDisplayString(_ctx.$t('modules.yourAccount.CONFIRM')), 1)])])], 4)]),
        _: 1
      }, 8, ["show"])])) : _createCommentVNode("", true)], 2)), [[_directive_loading, _ctx.loading]]) : _createCommentVNode("", true);
    };
  }
};